import * as React from 'react';

import styles from './list-item-meta.module.css';

export type Props = {
    avatar?: React.ReactNode;
    title: React.ReactNode | string;
    description?: React.ReactNode | string;
};

export function ListItemMeta(props: Props) {
    return (
        <div className={styles.meta}>
            {props.avatar ? <div className={styles.avatar}>{props.avatar}</div> : undefined}
            <div className={styles.text}>
                <div className={styles.title}>{props.title}</div>
                <div className={styles.description}>{props.description}</div>
            </div>
        </div>
    );
}
